import Cookies from 'js-cookie';

const requestHeaderNames = {
  appVersion: 'X-CVNA-AppVersion',
  bcid: 'X-CVNA-BrowserCookieId',
  deviceId: 'X-CVNA-DeviceId',
  deviceType: 'X-CVNA-DeviceType',
  platform: 'X-CVNA-Platform'
};

const createMobileRequestHeaders = () =>
  Object.values(requestHeaderNames).reduce(
    (headers: Record<string, string | undefined>, headerName) => {
      headers[headerName] = Cookies.get(headerName);

      return headers;
    },
    {}
  );

type DeviceInformation = {
  isBrowser?: number;
  isTablet?: number;
  isMobilePhone?: number;
};

export const getDeviceInformation = (): DeviceInformation => {
  let device: DeviceInformation = {};
  try {
    device = JSON.parse(localStorage.getItem('deviceInformation') || '{}');
  } catch (e) {
    device = {};
  }
  return device;
};

export const setDeviceType = () => {
  const device = getDeviceInformation();
  if (Number(device?.isBrowser)) {
    return 'Desktop';
  }

  if (Number(device?.isTablet)) {
    return 'Tablet';
  }

  if (Number(device?.isMobilePhone)) {
    return 'Mobile';
  }

  return 'Other';
};

const createWebRequestHeaders = () => {
  const headers = requestHeaderNames;

  return {
    [headers.appVersion]: '',
    [headers.bcid]: Cookies.get('BrowserCookieId') || '',
    [headers.deviceId]: '',
    [headers.deviceType]: setDeviceType(),
    [headers.platform]: 'Web'
  };
};

export const checkForMobileCookies = (mobileHeaders = createMobileRequestHeaders()) => {
  const { appVersion, platform } = requestHeaderNames;

  return mobileHeaders?.[appVersion] !== undefined || mobileHeaders?.[platform] !== undefined;
};

export const getRequestHeaders = () => {
  const mobileHeaders = createMobileRequestHeaders();

  return checkForMobileCookies(mobileHeaders) ? mobileHeaders : createWebRequestHeaders();
};

export const getRequestHeadersForThirdPartyLogin = () => createWebRequestHeaders();
